import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft, Search } from 'lucide-react';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-4" data-testid="404-page">
      <div className="text-center max-w-xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          {/* 404 Number */}
          <div className="relative mb-8">
            <h1 className="text-[150px] sm:text-[200px] font-bold text-zinc-900 leading-none select-none">
              404
            </h1>
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="text-6xl sm:text-7xl font-bold gradient-text-refined">404</span>
            </div>
          </div>

          {/* Message */}
          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-4">
            Sayfa Bulunamadı
          </h2>
          <p className="text-zinc-400 text-lg mb-8 leading-relaxed">
            Aradığınız sayfa mevcut değil veya taşınmış olabilir.
            <br />
            Ana sayfaya dönerek devam edebilirsiniz.
          </p>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link 
              to="/" 
              className="btn-gradient-refined inline-flex items-center gap-2"
            >
              <Home className="w-5 h-5" />
              Ana Sayfaya Dön
            </Link>
            <button 
              onClick={() => window.history.back()}
              className="btn-glow-refined inline-flex items-center gap-2"
            >
              <ArrowLeft className="w-5 h-5" />
              Geri Git
            </button>
          </div>

          {/* Quick Links */}
          <div className="mt-12 pt-8 border-t border-zinc-800">
            <p className="text-sm text-zinc-500 mb-4">Popüler Sayfalar</p>
            <div className="flex flex-wrap items-center justify-center gap-4">
              <Link to="/portfolyo" className="text-zinc-400 hover:text-white transition-colors text-sm">
                Portföy
              </Link>
              <span className="text-zinc-700">•</span>
              <Link to="/buyume-sistemleri" className="text-zinc-400 hover:text-white transition-colors text-sm">
                Büyüme Sistemleri
              </Link>
              <span className="text-zinc-700">•</span>
              <Link to="/metodoloji" className="text-zinc-400 hover:text-white transition-colors text-sm">
                Metodoloji
              </Link>
              <span className="text-zinc-700">•</span>
              <Link to="/iletisim" className="text-zinc-400 hover:text-white transition-colors text-sm">
                İletişim
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
